import { useEffect, useState } from "react";

export type Viewport = "mobile" | "tablet" | "desktop";

const BREAKPOINTS = { mobile: 768, tablet: 1024 } as const;

function compute(): Viewport {
  if (typeof window === "undefined") return "desktop";
  const w = window.innerWidth;
  if (w < BREAKPOINTS.mobile) return "mobile";
  if (w < BREAKPOINTS.tablet) return "tablet";
  return "desktop";
}

export function useViewport(): Viewport {
  const [vp, setVp] = useState<Viewport>(compute);
  useEffect(() => {
    function handler() { setVp(compute()); }
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);
  return vp;
}
